import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-clam-edit-item-details',
    templateUrl: './clam-edit-item-details.component.html',
    styleUrls: ['./clam-edit-item-details.component.scss'],
    standalone: false
})
export class ClamEditItemDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
